import { render, staticRenderFns } from "./profile-password-remind-sms-success.vue?vue&type=template&id=dc392c82"
import script from "./profile-password-remind-sms-success.vue?vue&type=script&lang=js"
export * from "./profile-password-remind-sms-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports